import { inject } from "@angular/core";
import { CanActivateFn } from "@angular/router";
import { SingleTabService } from "./single-tab.service";

export const singleTabGuard: CanActivateFn = async (_route, _state) => {
  const singleTabService = inject(SingleTabService);
  try {
    const canProceed = await singleTabService.initialize();
    return canProceed;
  } catch (error) {
    console.error("Single tab guard error:", error);
    // Allow navigation on error to prevent app from breaking
    return true;
  }
};
